import DataExtractionService from '../../dataExtraction/DataExtractionService';
import ScrappingMonitoringService from '../../scrapingMonitoring/scrappingMonitoringService';
import UrlService from '../../UrlService';

import { createCRMMessageHandler } from './crmMessageHandler';

export const hubspotMessageHandler = createCRMMessageHandler({
  isCompanyPage: UrlService.isHubspotCompanyPage,
  isContactPage: UrlService.isHubspotContactPage,
  extractionService: DataExtractionService.hubspot,
  onCustomDataChange: (commands, event, url) => {
    if (UrlService.isHubspotDealPage(url)) {
      const companyDomain = DataExtractionService.hubspot.extractCompanyDomain(event.data);
      companyDomain && commands.setCompanyDomain(companyDomain);
      commands.setCompanyPage({ companyDomain });

      if (commands.getState().isOpen) {
        ScrappingMonitoringService.dispatchScrappingEvent({ data: companyDomain, url });
      }
    }
  },
});
